import React, { useEffect, useRef, useState } from 'react';
import { characteristicEnrichmentControl, saveCharacteristicEnrichmentControl } from '../api/catalogSearchApi';
import styles from './EnrichmentQueueControl.module.css';

// [[Управление характеристиками]] #obsidian-marker
export default function EnrichmentQueueControl({ refreshToken = 0 }) {
  const [control, setControl] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const requestVersion = useRef(0);
  const mounted = useRef(false);
  const savingRef = useRef(false);

  useEffect(() => {
    mounted.current = true;
    const versionRef = requestVersion;
    return () => { mounted.current = false; ++versionRef.current; };
  }, []);

  useEffect(() => {
    const load = async () => {
      if (savingRef.current) return;
      const version = ++requestVersion.current;
      try {
        const next = await characteristicEnrichmentControl();
        if (mounted.current && version === requestVersion.current) {
          setControl(next);
          setError('');
        }
      } catch (cause) {
        if (mounted.current && version === requestVersion.current) setError(cause.message || 'Не удалось получить состояние очереди');
      }
    };
    load();
    const timer = setInterval(load, 8000);
    return () => clearInterval(timer);
  }, [refreshToken]);

  const toggle = async () => {
    if (!control || savingRef.current) return;
    const version = ++requestVersion.current;
    savingRef.current = true;
    setSaving(true);
    setError('');
    try {
      const next = await saveCharacteristicEnrichmentControl(!control.paused);
      if (mounted.current && version === requestVersion.current) setControl(next);
    } catch (cause) {
      if (mounted.current && version === requestVersion.current) setError(cause.message || 'Не удалось сохранить состояние очереди');
    } finally {
      savingRef.current = false;
      if (mounted.current) setSaving(false);
    }
  };

  return <div className={styles.panel}>
    <div className={styles.top}>
      <div>
        <strong>Очередь разбора категорий и характеристик</strong>
        <p>{control ? control.paused ? 'Приостановлена' : 'Включена' : 'Загружаем состояние…'}</p>
      </div>
      <button type="button" role="switch" aria-checked={control ? !control.paused : false} aria-label="Очередь разбора включена" disabled={!control || saving} className={styles.switch} onClick={toggle}>
        <span aria-hidden="true" /><span>Очередь разбора включена</span>
      </button>
    </div>
    {control && <div className={styles.counters}>
      <span>Категории: в очереди <strong>{control.categories?.pending ?? 0}</strong>, в работе <strong>{control.categories?.working ?? 0}</strong></span>
      <span>Характеристики: в очереди <strong>{control.fields?.pending ?? 0}</strong>, в работе <strong>{control.fields?.working ?? 0}</strong></span>
    </div>}
    <p className={styles.hint}>При паузе ожидающие задания сохраняются. Уже начатая обработка может завершиться.</p>
    {error && <p className={styles.error} role="alert">{error}</p>}
  </div>;
}
